import * as React from 'react';
import { useState } from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import { InfoText } from 'ui/common';

import styles from './expandable.scss';

export enum ExpandableButtonPosition {
  bottom = 'bottom',
  top = 'top'
}
export interface ExpandableProps {
  content: (collapsed: boolean) => React.ReactNode;
  textDisplayMore?: string;
  textDisplayLess?: string;
  textInfo?: string;
  useInfoText?: boolean;
  useMargin?: boolean;
  buttonPosition?: ExpandableButtonPosition;
}

export interface ExpandableState {
  collapsed: boolean;
}

export const Expandable = (props: ExpandableProps) => {

  const [collapsed, setCollapsed] = useState(true);

  const toggleExpander = (e: React.SyntheticEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setCollapsed(!collapsed);
  };
   
  const {content, textDisplayMore, textDisplayLess, useMargin = true, buttonPosition = ExpandableButtonPosition.bottom, 
    textInfo, useInfoText} = props;

  const text = collapsed ? textDisplayMore : textDisplayLess;

  const buttonMore = <span className={`expandable ${useMargin ? styles.useMargins : ''} ${styles.expandableLink}`}>
    {text ? ' ' : ''}
    <span className={`${!text ? styles.noText : ''}`} onClick={toggleExpander}>
      {text}{collapsed ? <MdExpandMore /> : <MdExpandLess />}
    </span></span>;

  if (buttonPosition === ExpandableButtonPosition.top) {
    return <>
      {buttonMore}
      <InfoText visible={true} text={textInfo}/>
      {content && content(collapsed)}
    </>;
  }
  return <>
    {content && content(collapsed)}
    {buttonMore}
    <InfoText visible={useInfoText} text={textInfo}/>
  </>;
};
